import React, { useContext, useEffect, useRef, useState } from "react";
import { ClipLoader } from "react-spinners";
import Blog from "../Home/Blog";
import { useLocation } from 'react-router-dom';
import Breadcrumb from "../Generic/Breadcrumb";
import { getBlogDetails } from "../Redux/API";
import { AppContext } from "../Redux/ContextProvider";

const Blogs = () => {
  const { appState, dispatch } = useContext(AppContext);
  const { blog, blogLoader } = appState;
  const [blogs, setBlogs] = useState([]);
  const myRef = useRef(null);
  const location = useLocation();
  const isHomePage = ["/", "/home", "/*"].includes(location.pathname);

  useEffect(() => {
    getBlogDetails(appState, dispatch)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    fetchRSSFeed()
  }, [blog])

  async function fetchRSSFeed() {
    const response = await fetch("https://rsarestaurant.com/rofda-cms/api/v1/RSSFeedList/json");
    const blogs = await response.json();
    setBlogs(blogs?.normalized?.items)
  }

  return (
    <>
      {
        blogLoader ?
          <div className='home-spinner'>
            <ClipLoader color={"#2A5350"} loading={true} size={60} />
          </div>
          :
          Object.keys(blog).length &&
          <>
            {!isHomePage &&
            <Breadcrumb
                pageName={blog.header_services_section.title || "Blog"}
                pageTitle={blog.header_services_section.title || "Blog"}
                id={`#${blog.header_services_section.title}`}
                image={blog.header_services_section.banner_image}
                myRef={myRef}
              />
            }
            <div ref={myRef}>
              <Blog blog={blog.blogs_section} blogs={blogs} />
            </div>
          </>
      }
    </>
  );
}

export default Blogs;